import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksCarouselStories, IComponentSharedTitleAndDescription, IEnum_Componentblockscarouselstories_Variant as Variant } from '@/graphql/__generated__/global/types';
import CenteredSlider from './CenteredSlider';
import LeftSlider from './LeftSlider';

export const BlocksCarouselStories = ({ id, titleDescription, stories, variant }: IComponentBlocksCarouselStories) => {
    let sliderComponent;

    switch (variant) {
        case Variant.CenteredSlider:
            sliderComponent = <CenteredSlider id={id} stories={stories} />;
            break;
        case Variant.LeftSlider:
            sliderComponent = <LeftSlider id={id} stories={stories} />;
            break;
        default:
            sliderComponent = <CenteredSlider id={id} stories={stories} />; // default centered slider
            break;
    }

    return (
        <>
            {titleDescription && (
                <Container>
                    <TitleAndDescription {...(titleDescription as IComponentSharedTitleAndDescription)} />
                </Container>
            )}
            {sliderComponent}
        </>
    );
};

export default BlocksCarouselStories;
